import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from "./common.service";
import {HttpClientService} from "./http-client.service";
import {ToastService} from "./toast.service";

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private cart = new BehaviorSubject<any[]>(this.getCartItems());
  cart$ = this.cart.asObservable();

  constructor(private common: CommonService, private http: HttpClientService, private toast: ToastService) {
    const storedCart = this.common.getStorage(this.common.carts);
    if (!storedCart) {
      this.saveCart([]);
    }

    window.addEventListener('storage', () => {
      this.cart.next(this.getCartItems());
    });
  }

  addToCart(item: any): void {
    const cart = this.getCartItems();
    const existingItem = cart.find((cartItem) => cartItem.itemId === item.itemId);

    if (existingItem) {
      if (existingItem.quantity >= existingItem.maxQuantity) return;
      existingItem.quantity += item.quantityStep || 1;
    } else {
      cart.push({ ...item, quantity: item.quantityStep || 1, itemId: item.itemId });
    }

    this.updateCart(cart);
  }

  removeFromCart(itemId: number, type: string = 'item'): void {
    if (type == 'item') {
      const updatedCart = this.getCartItems().filter((item) => item.itemId !== itemId);
      this.updateCart(updatedCart);
    } else {
      let updatedCart = this.getCartItems().map(item => {
        if (item.itemId == itemId && type !== 'item') {
          const { pendingOrderItemPolicyPlan, ...rest } = item;
          return rest;
        }
        return item;
      });
      this.updateCart(updatedCart);
    }
  }

  updateCartItemQuantity(itemId: number, quantity: number): void {
    const cart = this.getCartItems();
    const item = cart.find((cartItem) => cartItem.itemId === itemId);

    if (item) {
      item.quantity = quantity;
      if (item.quantity <= 0) this.removeFromCart(itemId);
      else this.updateCart(cart);
    }
  }

  getCartItems(): any[] {
    const storedCart = this.common.getStorage(this.common.carts);
    return typeof storedCart === 'object' ? storedCart : JSON.parse(storedCart);
  }

  getTotalPrice(): number {
    return this.getCartItems().reduce((total, item) => {
      const policyPrice = item.pendingOrderItemPolicyPlan?.price ? Number(item.pendingOrderItemPolicyPlan.price) : 0;
      const itemTotal = (item.sellingPrice + policyPrice) * item.quantity;
      return total + itemTotal;
    }, 0);
  }

  clearCart(): void {
    this.updateCart([]);
  }

  private updateCart(cart: any[]): void {
    if (cart.length) {
      this.http.post('store/cart', {cartItems: cart}).subscribe((res) => {
        if (res.responseStatus.toLowerCase() == 'success') {
          this.saveCart(res.response.cartResponse.cartItems);
          this.toast.success('Added successfully');
          this.cart.next(res.response.cartResponse.cartItems);
        }
      });
    } else {
      this.saveCart(cart);
      this.cart.next(cart);
    }
  }

  private saveCart(cart: any[]): void {
    this.common.setStorage(this.common.carts, JSON.stringify(cart));
  }
}
